import { render, staticRenderFns } from "./commercialGrade.vue?vue&type=template&id=685beff8&scoped=true"
import script from "./commercialGrade.vue?vue&type=script&lang=js"
export * from "./commercialGrade.vue?vue&type=script&lang=js"
import style0 from "./commercialGrade.vue?vue&type=style&index=0&id=685beff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685beff8",
  null
  
)

export default component.exports